module.exports = __webpack_public_path__ + "img/gift-card.4e453ea1.jpg";